import { useState, useEffect, useRef, Fragment } from "react";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/global/layout";
import { Tooltip } from "antd";
import FormControl from "../../components/common/FormControl";
import { toast } from "react-toastify";
import Select from "react-select";
import { IoMdClose } from "react-icons/io";
import methodModel from "../../methods/methods";
import { IoCloseOutline } from "react-icons/io5";
import { FiPlus } from "react-icons/fi";
import { Dialog, Transition } from '@headlessui/react'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import CardAnimation from "../../components/CardAnimation";
import Swal from "sweetalert2";

const AddEditCard = () => {
  const { id } = useParams()
  const [form, setform] = useState({
    name: "",
    categoryId: null,
    subCategoryId: null,
    envelopeId: null,
    audioIds: null,
    price: "",
    tags: [],
    image: "",
    text: "Text will be show here",
    textSize: 20,
    textColor: "#000",
    textPosition: {
      top: 10,
      right: 10
    },
    text2: "",
    text2Size: 20,
    text2Color: "#000",
    text2Position: {
      top: 10,
      right: 60
    },
    stickerImage: "",
    imageSize: 40,
    imagePosition: {
      top: 50,
      right: 10
    },
    stickerStamp: "",
    stickerStampSize: 20,
    stickerStampPosition: {
      top: 50,
      right: 40
    },
    addMoreText: false,
    stickereStampImage: false,

    secondImage: "",
    secondImageText: "Text will be show here",
    secondImageTextSize: 20,
    secondImageTextColor: "#000",
    secondImageTextPosition: {
      top: 10,
      right: 10
    },
    secondImageText2: "",
    secondImageText2Size: 20,
    secondImageText2Color: "#000",
    secondImageText2Position: {
      top: 10,
      right: 60
    },
    secondImageStickerImage: "",
    secondImageSize: 40,
    secondImagePosition: {
      top: 50,
      right: 10
    },
    secondImageStickerStamp: "",
    secondImageStickerStampSize: 20,
    secondImageStickerStampPosition: {
      top: 50,
      right: 40
    },
    secondImageAddMoreText: false,
    secondImageStickereStampImage: false
  })
  const [categories, setCategories] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [envelopes, setEnvelopes] = useState([])
  const [audios, setAudios] = useState([])
  const [submitted, setSubmitted] = useState(false)
  const [tag, setTag] = useState()
  const history = useNavigate()
  const formValidation = [
    { key: "image", required: true, message: "Left Side Image is required" },
    { key: "secondImage", required: true, message: "Right Side Image is required" },
  ]
  // State to open and close preview modal
  let [isOpen, setIsOpen] = useState(false)

  // Refs for draggable elements of left side image
  const imageRef = useRef(null);
  const textRef = useRef(null);
  const stickerImageRef = useRef(null);
  const text2Ref = useRef(null);
  const stickerStampRef = useRef(null);

  // Refs for draggable elements of right side image
  const secondImageRef = useRef(null);
  const secondImageTextRef = useRef(null);
  const secondImageStickerImageRef = useRef(null);
  const secondImageText2Ref = useRef(null);
  const secondImageStickerStampRef = useRef(null);

  useEffect(() => {
    getCategories()
    getEnvelopes()
    getAudios()
    if (id) {
      getCardDetail()
    }
  }, [])

  useEffect(() => {
    getSubCategories(form?.categoryId?.value)
  }, [form.categoryId])

  const getCategories = () => {
    ApiClient.get(`category/listing?status=active`).then(res => {
      if (res?.success) {
        setCategories(res?.data?.map((item) => {
          return ({ ...item, value: item?.id || item?._id, label: item?.name })
        }))
      }
    })
  }
  const getSubCategories = (id = "") => {
    ApiClient.get(`category/sub-cat/list?status=active&categoryId=${id}`).then(res => {
      if (res?.success) {
        setSubCategories(res?.data?.map((item) => {
          return ({ value: item?.id || item?._id, label: item?.name })
        }))
      }
    })
  }

  const getEnvelopes = () => {
    ApiClient.get(`envelope/listing?status=active`).then((res => {
      if (res.success) {
        // let envelopesArray = [{ value: "all", label: "Select All" }]
        // res?.data?.map((item) => {
        //   envelopesArray.push({ value: item?.id || item?._id, label: item?.name })
        // })
        setEnvelopes(res?.data?.map((item) => {
          return ({ ...item, value: item?.id || item?._id, label: item?.name })
        }))
      }
    }))
  }
  const getAudios = () => {
    ApiClient.get(`audio/list?status=active`).then((res => {
      if (res.success) {
        let audioArray = [{ value: "all", label: "Select All" }]
        res?.data?.map((item) => {
          audioArray.push({ value: item?.id || item?._id, label: item?.title })
        })
        setAudios(audioArray)
      }
    }))
  }

  const getCardDetail = () => {
    loader(true)
    ApiClient.get(`card/detail?id=${id}`).then((res) => {
      if (res.success) {
        setform({
          name: res?.data?.name,
          categoryId: res?.data?.categoryId?.name ? { ...res?.data?.categoryId, value: res?.data?.categoryId?.id || res?.data?.categoryId?._id, label: res?.data?.categoryId?.name } : null,
          subCategoryId: res?.data?.subCategoryId?.name ? { value: res?.data?.subCategoryId?.id || res?.data?.subCategoryId?._id, label: res?.data?.subCategoryId?.name } : null,
          envelopeId: res?.data?.envelopeId?.name ? { ...res?.data?.envelopeId, value: res?.data?.envelopeId?.id || res?.data?.envelopeId?._id, label: res?.data?.envelopeId?.name } : null,
          // envelopeId: res?.data?.envelope_details?.length != 0 ? res?.data?.envelope_details?.map((item) => ({ value: item?.id || item?._id, label: item?.name })) : null,
          audioIds: res?.data?.audio_details?.length != 0 ? res?.data?.audio_details?.map((item) => ({ value: item?.id || item?._id, label: item?.title })) : null,
          price: res?.data?.price,
          image: res?.data?.image,
          tags: res?.data?.tags,
          stickerImage: res?.data?.stickerImage,
          textPosition: res?.data?.textPosition,
          imagePosition: res?.data?.imagePosition,
          textSize: res?.data?.textSize,
          textColor: res?.data?.textColor,
          imageSize: res?.data?.imageSize,
          text: res?.data?.text,
          text2: res?.data?.text2,
          text2Size: res?.data?.text2Size,
          text2Color: res?.data?.text2Color,
          text2Position: res?.data?.text2Position,
          stickerStamp: res?.data?.stickerStamp,
          stickerStampSize: res?.data?.stickerStampSize,
          stickerStampPosition: res?.data?.stickerStampPosition,
          addMoreText: res?.data?.addMoreText,
          stickereStampImage: res?.data?.stickereStampImage,
          secondImage: res?.data?.secondImage,
          secondImageText: res?.data?.secondImageText,
          secondImageTextSize: res?.data?.secondImageTextSize,
          secondImageTextColor: res?.data?.secondImageTextColor,
          secondImageTextPosition: res?.data?.secondImageTextPosition,
          secondImageText2: res?.data?.secondImageText2,
          secondImageText2Size: res?.data?.secondImageText2Size,
          secondImageText2Color: res?.data?.secondImageText2Color,
          secondImageText2Position: res?.data?.secondImageText2Position,
          secondImageStickerImage: res?.data?.secondImageStickerImage,
          secondImageSize: res?.data?.secondImageSize,
          secondImagePosition: res?.data?.secondImagePosition,
          secondImageStickerStamp: res?.data?.secondImageStickerStamp,
          secondImageStickerStampSize: res?.data?.secondImageStickerStampSize,
          secondImageStickerStampPosition: res?.data?.secondImageStickerStampPosition,
          secondImageAddMoreText: res?.data?.secondImageAddMoreText,
          secondImageStickereStampImage: res?.data?.secondImageStickereStampImage
        })
      }
      else {
        toast?.error(res?.message)
      }
      loader(false)
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setSubmitted(true)
    let invalid = methodModel.getFormError(formValidation, form)
    if (invalid) return
    let method = "post"
    let url = "card/add"
    let value = {
      ...form,
      id: id || "",
      categoryId: form?.categoryId?.value || "",
      subCategoryId: form?.subCategoryId?.value || "",
      envelopeId: form?.envelopeId?.value || "",
      // envelopeId: form?.envelopeId?.map((item) => item?.value),
      audioIds: form?.audioIds?.map((item) => item?.value),
      tags: form?.tags?.filter((item) => item?.length > 0)
    }
    if (id) {
      method = "put"
      url = "card/update"
    } else {
      delete value.id
    }
    loader(true)
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        history(`/card`)
      }
      loader(false)
    })
  }

  const handleEnvelopes = (e, key) => {
    if (e?.some((item) => item?.value == "all")) {
      setform({
        ...form, [key]: envelopes?.filter((item) => {
          if (item?.value != 'all') return ({ value: item?.id || item?._id, label: item?.name })
        })
      })
    } else {
      setform({ ...form, [key]: e })
    }
  }

  const handleAudios = (e, key) => {
    if (e?.some((item) => item?.value == "all")) {
      setform({
        ...form, [key]: audios?.filter((item) => {
          if (item?.value != 'all') return ({ value: item?.id || item?._id, label: item?.name })
        })
      })
    } else {
      setform({ ...form, [key]: e })
    }
  }

  // It push tags in tags array of form state and clear the tag state
  const addTags = () => {
    if (!tag) return
    const tagsArray = form?.tags
    tagsArray.push(tag)
    setTag("")
    setform({ ...form, tags: tagsArray })
  }
  // This function delete tag with the help of index argument and update the tags data form state
  const deleteTag = (index) => {
    const tagsArray = form?.tags
    delete tagsArray[index]
    setform({ ...form, tags: tagsArray })
  }

  // Handle upload image and set image path on key (getting through the parameters) of form state
  const ImageUpload = (e, key) => {
    let files = e.target.files
    let file = files.item(0)
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"]; // Add more image types if needed
    if (!allowedTypes.includes(file.type)) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Only JPG and PNG images are allowed.",
      });
      return;
    }
    loader(true)
    ApiClient.postFormData('upload/image', { file: file }).then(res => {
      if (res.success) {
        setform({ ...form, [key]: res?.fileName })
      }
      loader(false)
    })
  }

  const handleCategory = (e) => {
    setform({ ...form, categoryId: e, subCategoryId: null })
    getSubCategories(e?.value || "")
  }

  const handleAddMoreButtons = (key, value) => {
    if (!value) {
      if (key === "addMoreText") {
        setform({ ...form, text2: "", text2Size: 20, text2Color: "#FFFFFF", text2Position: { top: 10, right: 60 }, [key]: value })
      } else {
        setform({ ...form, stickerStamp: "", stickerStampSize: 20, stickerStampPosition: { top: 50, right: 40 }, [key]: value })
      }
    } else {
      setform({ ...form, [key]: value })
    }
  }

  // Text & Image drag and drop functionality handling through the arguments passing ref and key to get the position and set the form state
  const [dragging, setDragging] = useState(false);
  const [initialPos, setInitialPos] = useState({ x: 0, y: 0 });
  const onDragStart = (e, ref) => {
    setDragging(true);
    const rect = ref.current.getBoundingClientRect();
    setInitialPos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  };
  const onDrag = (e, parentRef, ref, key) => {
    if (dragging) {
      const imageRect = parentRef.current.getBoundingClientRect();
      const dummyTextRect = ref.current.getBoundingClientRect();

      let newX = e.clientX - initialPos.x - imageRect.left;
      let newY = e.clientY - initialPos.y - imageRect.top;

      // Constrain within parent boundaries
      if (newX < 0) {
        newX = 0;
      } else if (newX + dummyTextRect.width > imageRect.width) {
        newX = imageRect.width - dummyTextRect.width;
      }

      if (newY < 0) {
        newY = 0;
      } else if (newY + dummyTextRect.height > imageRect.height) {
        newY = imageRect.height - dummyTextRect.height;
      }

      // Calculate percentage positions
      const percentTop = (newY / imageRect.height) * 100;
      const percentRight = ((imageRect.width - newX - dummyTextRect.width) / imageRect.width) * 100;

      setform(prevForm => ({
        ...prevForm,
        [key]: {
          top: parseFloat(percentTop).toFixed(2),
          right: parseFloat(percentRight).toFixed(2)
        }
      }));
    }
  };
  const onDragEnd = () => {
    setDragging(false);
  };
  // Left Side Card CSS
  const textElementStyle = {
    position: 'absolute',
    top: `${form?.textPosition?.top}%`,
    right: `${form?.textPosition?.right}%`,
    fontSize: `${form?.textSize}px`,
    color: form?.textColor,
    height: 'auto',
    cursor: isOpen ? 'default' : 'move',
    userSelect: 'none',
    textAlign: 'center',
    lineHeight: 'normal',
  };
  const imageElementStyle = {
    position: 'absolute',
    top: `${form?.imagePosition?.top}%`,
    right: `${form?.imagePosition?.right}%`,
    width: `${form?.imageSize}%`,
    cursor: isOpen ? 'default' : 'move',
  };
  const text2ElementStyle = {
    position: 'absolute',
    top: `${form?.text2Position?.top}%`,
    right: `${form?.text2Position?.right}%`,
    fontSize: `${form?.text2Size}px`,
    color: form?.text2Color,
    height: 'auto',
    cursor: isOpen ? 'default' : 'move',
    userSelect: 'none',
    textAlign: 'center',
    lineHeight: 'normal',
  };
  const stickerStampElementStyle = {
    position: 'absolute',
    top: `${form?.stickerStampPosition?.top}%`,
    right: `${form?.stickerStampPosition?.right}%`,
    width: `${form?.stickerStampSize}%`,
    cursor: isOpen ? 'default' : 'move',
  };

  // Right Side Card CSS
  const secondImageTextElementStyle = {
    position: 'absolute',
    top: `${form?.secondImageTextPosition?.top}%`,
    right: `${form?.secondImageTextPosition?.right}%`,
    fontSize: `${form?.secondImageTextSize}px`,
    color: form?.secondImageTextColor,
    height: 'auto',
    cursor: isOpen ? 'default' : 'move',
    userSelect: 'none',
    textAlign: 'center',
    lineHeight: 'normal',
  };
  const secondImageElementStyle = {
    position: 'absolute',
    top: `${form?.secondImagePosition?.top}%`,
    right: `${form?.secondImagePosition?.right}%`,
    width: `${form?.secondImageSize}%`,
    cursor: isOpen ? 'default' : 'move',
  };
  const secondImageText2ElementStyle = {
    position: 'absolute',
    top: `${form?.secondImageText2Position?.top}%`,
    right: `${form?.secondImageText2Position?.right}%`,
    fontSize: `${form?.secondImageText2Size}px`,
    color: form?.secondImageText2Color,
    height: 'auto',
    cursor: isOpen ? 'default' : 'move',
    userSelect: 'none',
    textAlign: 'center',
    lineHeight: 'normal',
  };
  const secondImageStickerStampElementStyle = {
    position: 'absolute',
    top: `${form?.secondImageStickerStampPosition?.top}%`,
    right: `${form?.secondImageStickerStampPosition?.right}%`,
    width: `${form?.secondImageStickerStampSize}%`,
    cursor: isOpen ? 'default' : 'move',
  };

  const modules = {
    toolbar: [
      [{ 'header': [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'align': [] }], // 👈 alignment options: left, center, right, justify
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['clean']
    ]
  };

  return (
    <>
      <Layout>
        <form onSubmit={handleSubmit}>
          <div className="pprofile1">
            <div className="flex items-center mb-8">
              <Tooltip placement="top" title="Back">
                <Link to={`/card`} className="!px-4 py-2 flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3">
                  <i className="fa fa-angle-left text-lg"></i>
                </Link>
              </Tooltip>
              <div>
                <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">{id ? "Edit" : "Add"} Card</h3>
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div className="mb-3">
                <FormControl
                  type="text"
                  name="name"
                  label="Name"
                  placeholder="Name"
                  value={form?.name}
                  onChange={(e) => setform({ ...form, name: e })}
                  required
                />
              </div>
              <div className="mb-3">
                <label>Category <span className="text-red-600"> *</span></label>
                <Select
                  value={form?.categoryId}
                  onChange={e => handleCategory(e)}
                  options={categories}
                  className="capitalize"
                  placeholder="Select Category"
                  required
                />
              </div>
              <div className="mb-3">
                <label>Sub Category <span className="text-red-600"> *</span></label>
                <Select
                  value={form?.subCategoryId}
                  onChange={e => setform({ ...form, subCategoryId: e })}
                  options={subCategories}
                  className="capitalize"
                  placeholder="Select Sub Category"
                  required
                />
              </div>
              <div className="mb-3">
                <label>Front Image <span className="text-red-600"> *</span></label>
                <Select
                  value={form?.envelopeId}
                  options={envelopes}
                  className="capitalize"
                  placeholder="Select Front Image"
                  onChange={e => setform({ ...form, envelopeId: e })}
                  // onChange={e => handleEnvelopes(e, 'envelopeId')}
                  // closeMenuOnSelect={false}
                  // isMulti
                  required
                />
              </div>
              <div className="mb-3">
                <label>Audios </label>
                <Select
                  value={form?.audioIds}
                  onChange={e => handleAudios(e, 'audioIds')}
                  options={audios}
                  className="capitalize"
                  placeholder="Select Audios"
                  closeMenuOnSelect={false}
                  isMulti
                />
              </div>
              <div className="mb-3">
                <label>Price (USD)<span className="text-red-600"> *</span></label>
                <input type="text" value={form?.price} onChange={e => setform({ ...form, price: methodModel.isNumber(e) })} maxLength={10} required autoComplete="one-time-code" placeholder="Price (USD)" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" />
              </div>
              <div className="mb-3">
                <label>Tags</label>
                <div className="flex">
                  <input type="text" value={tag} onChange={e => setTag(e.target.value)} autoComplete="one-time-code" placeholder="Tag" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" />
                  <button type="button" onClick={e => addTags()} className="text-white bg-[#f98745] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center ml-3">Add</button>
                </div>
                <div className="flex">
                  {form?.tags?.map((item, index) => {
                    return <div className="relative flex items-center bg-yellow-100 text-yellow-800 px-2 border border-yellow-300 gap-2 rounded my-4 mr-1" key={index}>
                      <span className="text-xs font-medium py-1">{item}</span>
                      <IoMdClose className="hover:text-red-600 pointer" onClick={e => deleteTag(index)} size={20} />
                    </div>
                  })}
                </div>
              </div>
            </div>
            {/* Left Side Image & Text */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div className="mb-3 mr-4">
                <label className="lablefontcls normal-case">Left Side Image (JPG/PNG) (Dimension: 740 px width x 880 px height) <span className="text-red-600"> *</span></label>
                {form?.image ?
                  <div>
                    <div className="relative" ref={imageRef}>
                      <img src={methodModel.userImg(form?.image)} className="w-full h-full" id="image" draggable="false" />
                      <IoCloseOutline title="remove image" className="absolute -top-6 -right-2 pointer text-red-600" onClick={e => setform({ ...form, image: "" })} size={25} />
                      {/* Text & Sticker Image Fields */}
                      <div id="textId"
                        ref={textRef}
                        style={textElementStyle}
                        onMouseDown={e => onDragStart(e, textRef)}
                        onMouseMove={e => onDrag(e, imageRef, textRef, "textPosition")}
                        onMouseUp={e => onDragEnd(e)}
                        onMouseLeave={e => onDragEnd(e)}
                        className={`border-dashed border-2 border-yellow-500 text-xl p-1 cursor-grab`} dangerouslySetInnerHTML={{ __html: form?.text }}></div>
                      {form?.stickerImage &&
                        <img id="StickerImageId"
                          ref={stickerImageRef}
                          style={imageElementStyle}
                          onMouseDown={e => onDragStart(e, stickerImageRef)}
                          onMouseMove={e => onDrag(e, imageRef, stickerImageRef, "imagePosition")}
                          onMouseUp={e => onDragEnd(e)}
                          draggable="false"
                          onMouseLeave={e => onDragEnd(e)}
                          src={methodModel.noImg(form?.stickerImage)} className={`border-dashed border-2 border-yellow-500 text-2xl text-white p-1 disableImageSelect`} />
                      }
                      {/* Add More Text & Sticker Stamp Fields */}
                      {form?.text2 &&
                        <div
                          ref={text2Ref}
                          style={text2ElementStyle}
                          onMouseDown={e => onDragStart(e, text2Ref)}
                          onMouseMove={e => onDrag(e, imageRef, text2Ref, "text2Position")}
                          onMouseUp={e => onDragEnd(e)}
                          onMouseLeave={e => onDragEnd(e)}
                          dangerouslySetInnerHTML={{ __html: form?.text2 }}
                          className={`border-dashed border-2 border-yellow-500 text-xl p-1 cursor-grab`}></div>
                      }
                      {form?.stickerStamp &&
                        <img
                          ref={stickerStampRef}
                          style={stickerStampElementStyle}
                          onMouseDown={e => onDragStart(e, stickerStampRef)}
                          onMouseMove={e => onDrag(e, imageRef, stickerStampRef, "stickerStampPosition")}
                          onMouseUp={e => onDragEnd(e)}
                          draggable="false"
                          onMouseLeave={e => onDragEnd(e)}
                          src={methodModel.noImg(form?.stickerStamp)} className={`border-dashed border-2 border-yellow-500 text-2xl text-white p-1 disableImageSelect`} />
                      }
                    </div>
                  </div>
                  :
                  <label className={`flex items-center justify-center cursor-pointer text-black-800 bg-[#fff] focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 border-2 border-dashed border-gray-200 w-full`} style={{ gap: '8px' }}>
                    <FiPlus />
                    <input
                      id="dropzone-file"
                      type="file"
                      className="hidden"
                      accept=".jpg, .jpeg, .png"
                      value={""}
                      onChange={e => ImageUpload(e, "image")}
                    />
                    Upload Image
                  </label>
                }
                {submitted && !form?.image && <div className="text-red-600">Left side image is required</div>}
              </div>
              {form?.image &&
                <div className="mb-3">
                  <label>Text</label>
                  <div className="mb-3">
                    <div className="flex items-center align-center">
                      <ReactQuill theme="snow" value={form?.text} onChange={(content) => setform((prev) => ({ ...prev, text: content }))} className="w-full" modules={modules} />
                      {/* <input type="text" value={form?.text} onChange={e => setform({ ...form, text: e.target.value })} className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" placeholder="Text" /> */}
                    </div>
                  </div>
                  <label>Text Color</label>
                  <div className="mb-3">
                    <div className="flex items-center align-center">
                      <input type="color" value={form?.textColor} onChange={e => setform({ ...form, textColor: e.target.value })} className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" />
                    </div>
                  </div>
                  <label>Text Size</label>
                  <div className="mb-3">
                    <div className="flex items-center align-center">
                      <input type="range" value={form?.textSize} onChange={e => setform({ ...form, textSize: e.target.value })} max={100} className="w-full h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer range-sm dark:bg-gray-700" />
                      <span>{form?.textSize}px</span>
                    </div>
                  </div>
                  <label>Sticker Image</label>
                  <div className="mb-3">
                    <div className="flex items-center align-center">
                      <label className={`flex items-center justify-center cursor-pointer text-black-800 bg-[#fff] focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 border-2 border-dashed border-gray-200 w-full`} style={{ gap: '8px' }}>
                        <FiPlus />
                        <input
                          id="dropzone-file"
                          type="file"
                          className="hidden"
                          onChange={e => ImageUpload(e, 'stickerImage')}
                        />
                        {form?.stickerImage ? "Change" : "Upload"} Image
                      </label>
                    </div>
                  </div>
                  <label>Image Size</label>
                  <div className="mb-3">
                    <div className="flex items-center align-center">
                      <input type="range" value={form?.imageSize} onChange={e => setform({ ...form, imageSize: e.target.value })} max={100} className="w-full h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer range-sm dark:bg-gray-700" />
                      <span>{form?.imageSize}%</span>
                    </div>
                  </div>
                  <div className="bg-gray-200 border border-grey inline-flex rounded-lg p-2">
                    <div className="flex items-center gap-2">
                      <button type="button" onClick={e => handleAddMoreButtons("addMoreText", !form?.addMoreText)} className={`${form?.addMoreText && "bg-primary !text-white"} font-medium rounded-lg text-sm px-5 py-2.5 text-center`}>{form?.addMoreText ? "Remove" : "Add"} More Text</button>
                      <button type="button" onClick={e => handleAddMoreButtons("stickereStampImage", !form?.stickereStampImage)} className={`${form?.stickereStampImage && "bg-primary !text-white"} font-medium rounded-lg text-sm px-5 py-2.5 text-center`}>{form?.stickereStampImage ? "Remove" : "Add"} Sticker Stamp</button>
                    </div>
                  </div>
                  {form?.addMoreText &&
                    <div className="bg-gray-50 p-4 mt-4">
                      <div className="my-3">
                        <label>Text 2 Size</label>
                        <div className="mb-3">
                          <div className="flex items-center align-center">
                            <input type="range" value={form?.text2Size} onChange={e => setform({ ...form, text2Size: e.target.value })} max={100} className="w-full h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer range-sm dark:bg-gray-700" />
                            <span>{form?.text2Size}px</span>
                          </div>
                        </div>
                        <label>Text 2</label>
                        <div className="mb-3">
                          <div className="flex items-center align-center">
                            <ReactQuill theme="snow" value={form?.text2} onChange={(content) => setform((prev) => ({ ...prev, text2: content }))} className="w-full" modules={modules} />
                            {/* <input type="text" value={form?.text2} onChange={e => setform({ ...form, text2: e.target.value })} className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" placeholder="Text 2" /> */}
                          </div>
                        </div>
                        <label>Text 2 Color</label>
                        <div className="mb-3">
                          <div className="flex items-center align-center">
                            <input type="color" value={form?.text2Color} onChange={e => setform({ ...form, text2Color: e.target.value })} className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" />
                          </div>
                        </div>
                      </div>
                    </div>}
                  {form?.stickereStampImage &&
                    <div className="bg-gray-50 p-4 mt-4">
                      <div className="my-3">
                        <label>Sticker stamp</label>
                        <div className="mb-3">
                          <div className="flex items-center align-center">
                            <label className={`flex items-center justify-center cursor-pointer text-black-800 bg-[#fff] focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 border-2 border-dashed border-gray-200 w-full`} style={{ gap: '8px' }}>
                              <FiPlus />
                              <input
                                id="dropzone-file"
                                type="file"
                                className="hidden"
                                onChange={e => ImageUpload(e, 'stickerStamp')}
                              />
                              {form?.stickerStamp ? "Change" : "Upload"} Image
                            </label>
                          </div>
                        </div>
                        {form?.stickerStamp &&
                          <>
                            <label>Sticker Stamp Size</label>
                            <div className="mb-3">
                              <div className="flex items-center align-center">
                                <input type="range" value={form?.stickerStampSize} onChange={e => setform({ ...form, stickerStampSize: e.target.value })} max={100} className="w-full h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer range-sm dark:bg-gray-700" />
                                <span>{form?.stickerStampSize}%</span>
                              </div>
                            </div>
                          </>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
            {/* Right Side Image & Text */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div className="mb-3 mr-4">
                <label className="lablefontcls normal-case">Right Side Image (JPG/PNG) (Dimension: 740 px width x 880 px height) <span className="text-red-600">*</span></label>
                {form?.secondImage ?
                  <div>
                    <div className="relative" ref={secondImageRef}>
                      <img src={methodModel.userImg(form?.secondImage)} className="w-full h-full" id="secondImage" draggable="false" />
                      <IoCloseOutline title="remove image" className="absolute -top-6 -right-2 pointer text-red-600" onClick={e => setform({ ...form, secondImage: "" })} size={25} />
                      {/* Text & Sticker Image Fields */}
                      <div id="secondImageTextId"
                        ref={secondImageTextRef}
                        style={secondImageTextElementStyle}
                        onMouseDown={e => onDragStart(e, secondImageTextRef)}
                        onMouseMove={e => onDrag(e, secondImageRef, secondImageTextRef, "secondImageTextPosition")}
                        onMouseUp={e => onDragEnd(e)}
                        onMouseLeave={e => onDragEnd(e)}
                        className={`border-dashed border-2 border-yellow-500 text-xl p-1 cursor-grab`} dangerouslySetInnerHTML={{ __html: form?.secondImageText }}></div>
                      {form?.secondImageStickerImage &&
                        <img id="StickerImageId"
                          ref={secondImageStickerImageRef}
                          style={secondImageElementStyle}
                          onMouseDown={e => onDragStart(e, secondImageStickerImageRef)}
                          onMouseMove={e => onDrag(e, secondImageRef, secondImageStickerImageRef, "secondImagePosition")}
                          onMouseUp={e => onDragEnd(e)}
                          draggable="false"
                          onMouseLeave={e => onDragEnd(e)}
                          src={methodModel.noImg(form?.secondImageStickerImage)} className={`border-dashed border-2 border-yellow-500 text-2xl text-white p-1 disableImageSelect`} />
                      }
                      {/* Add More Text & Sticker Stamp Fields */}
                      {form?.secondImageText2 &&
                        <div
                          ref={secondImageText2Ref}
                          style={secondImageText2ElementStyle}
                          onMouseDown={e => onDragStart(e, secondImageText2Ref)}
                          onMouseMove={e => onDrag(e, secondImageRef, secondImageText2Ref, "secondImageText2Position")}
                          onMouseUp={e => onDragEnd(e)}
                          onMouseLeave={e => onDragEnd(e)}
                          className={`border-dashed border-2 border-yellow-500 text-xl p-1 cursor-grab`} dangerouslySetInnerHTML={{ __html: form?.secondImageText2 }}></div>
                      }
                      {form?.secondImageStickerStamp &&
                        <img
                          ref={secondImageStickerStampRef}
                          style={secondImageStickerStampElementStyle}
                          onMouseDown={e => onDragStart(e, secondImageStickerStampRef)}
                          onMouseMove={e => onDrag(e, secondImageRef, secondImageStickerStampRef, "secondImageStickerStampPosition")}
                          onMouseUp={e => onDragEnd(e)}
                          draggable="false"
                          onMouseLeave={e => onDragEnd(e)}
                          src={methodModel.noImg(form?.secondImageStickerStamp)} className={`border-dashed border-2 border-yellow-500 text-2xl text-white p-1 disableImageSelect`} />
                      }
                    </div>
                  </div>
                  :
                  <label className={`flex items-center justify-center cursor-pointer text-black-800 bg-[#fff] focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 border-2 border-dashed border-gray-200 w-full`} style={{ gap: '8px' }}>
                    <FiPlus />
                    <input
                      id="dropzone-file"
                      type="file"
                      className="hidden"
                      accept=".jpg, .jpeg, .png"
                      value={""}
                      onChange={e => ImageUpload(e, "secondImage")}
                    />
                    Upload Image
                  </label>
                }
                {submitted && !form?.secondImage && <div className="text-red-600">Right side image is required</div>}
              </div>
              {form?.secondImage &&
                <div className="mb-3">
                  <label>Text</label>
                  <div className="mb-3">
                    <div className="flex items-center align-center">
                      <ReactQuill theme="snow" value={form?.secondImageText} onChange={(content) => setform((prev) => ({ ...prev, secondImageText: content }))} className="w-full" modules={modules} />
                      {/* <input type="text" value={form?.secondImageText} onChange={e => setform({ ...form, secondImageText: e.target.value })} className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" placeholder="Text" /> */}
                    </div>
                  </div>
                  <label>Text Color</label>
                  <div className="mb-3">
                    <div className="flex items-center align-center">
                      <input type="color" value={form?.secondImageTextColor} onChange={e => setform({ ...form, secondImageTextColor: e.target.value })} className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" />
                    </div>
                  </div>
                  <label>Text Size</label>
                  <div className="mb-3">
                    <div className="flex items-center align-center">
                      <input type="range" value={form?.secondImageTextSize} onChange={e => setform({ ...form, secondImageTextSize: e.target.value })} max={100} className="w-full h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer range-sm dark:bg-gray-700" />
                      <span>{form?.secondImageTextSize}px</span>
                    </div>
                  </div>
                  <label>Sticker Image</label>
                  <div className="mb-3">
                    <div className="flex items-center align-center">
                      <label className={`flex items-center justify-center cursor-pointer text-black-800 bg-[#fff] focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 border-2 border-dashed border-gray-200 w-full`} style={{ gap: '8px' }}>
                        <FiPlus />
                        <input
                          id="dropzone-file"
                          type="file"
                          className="hidden"
                          onChange={e => ImageUpload(e, 'secondImageStickerImage')}
                        />
                        {form?.secondImageStickerImage ? "Change" : "Upload"} Image
                      </label>
                    </div>
                  </div>
                  <label>Image Size</label>
                  <div className="mb-3">
                    <div className="flex items-center align-center">
                      <input type="range" value={form?.secondImageSize} onChange={e => setform({ ...form, secondImageSize: e.target.value })} max={100} className="w-full h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer range-sm dark:bg-gray-700" />
                      <span>{form?.secondImageSize}%</span>
                    </div>
                  </div>
                  <div className="bg-gray-200 border border-grey inline-flex rounded-lg p-2">
                    <div className="flex items-center gap-2">
                      <button type="button" onClick={e => handleAddMoreButtons("secondImageAddMoreText", !form?.secondImageAddMoreText)} className={`${form?.secondImageAddMoreText && "bg-primary !text-white"} font-medium rounded-lg text-sm px-5 py-2.5 text-center`}>{form?.secondImageAddMoreText ? "Remove" : "Add"} More Text</button>
                      <button type="button" onClick={e => handleAddMoreButtons("secondImageStickereStampImage", !form?.secondImageStickereStampImage)} className={`${form?.secondImageStickereStampImage && "bg-primary !text-white"} font-medium rounded-lg text-sm px-5 py-2.5 text-center`}>{form?.secondImageStickereStampImage ? "Remove" : "Add"} Sticker Stamp</button>
                    </div>
                  </div>
                  {form?.secondImageAddMoreText &&
                    <div className="bg-gray-50 p-4 mt-4">
                      <div className="my-3">
                        <label>Text 2 Size</label>
                        <div className="mb-3">
                          <div className="flex items-center align-center">
                            <input type="range" value={form?.secondImageText2Size} onChange={e => setform({ ...form, secondImageText2Size: e.target.value })} max={100} className="w-full h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer range-sm dark:bg-gray-700" />
                            <span>{form?.secondImageText2Size}px</span>
                          </div>
                        </div>
                        <label>Text 2</label>
                        <div className="mb-3">
                          <div className="flex items-center align-center">
                            <ReactQuill theme="snow" value={form?.secondImageText2} onChange={(content) => setform((prev) => ({ ...prev, secondImageText2: content }))} className="w-full" modules={modules} />
                            {/* <input type="text" value={form?.secondImageText2} onChange={e => setform({ ...form, secondImageText2: e.target.value })} className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" placeholder="Text 2" /> */}
                          </div>
                        </div>
                        <label>Text 2 Color</label>
                        <div className="mb-3">
                          <div className="flex items-center align-center">
                            <input type="color" value={form?.secondImageText2Color} onChange={e => setform({ ...form, secondImageText2Color: e.target.value })} className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" />
                          </div>
                        </div>
                      </div>
                    </div>}
                  {form?.secondImageStickereStampImage &&
                    <div className="bg-gray-50 p-4 mt-4">
                      <div className="my-3">
                        <label>Sticker stamp</label>
                        <div className="mb-3">
                          <div className="flex items-center align-center">
                            <label className={`flex items-center justify-center cursor-pointer text-black-800 bg-[#fff] focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 border-2 border-dashed border-gray-200 w-full`} style={{ gap: '8px' }}>
                              <FiPlus />
                              <input
                                id="dropzone-file"
                                type="file"
                                className="hidden"
                                onChange={e => ImageUpload(e, 'secondImageStickerStamp')}
                              />
                              {form?.secondImageStickerStamp ? "Change" : "Upload"} Image
                            </label>
                          </div>
                        </div>
                        {form?.secondImageStickerStamp &&
                          <>
                            <label>Sticker Stamp Size</label>
                            <div className="mb-3">
                              <div className="flex items-center align-center">
                                <input type="range" value={form?.secondImageStickerStampSize} onChange={e => setform({ ...form, secondImageStickerStampSize: e.target.value })} max={100} className="w-full h-1 bg-gray-200 rounded-lg appearance-none cursor-pointer range-sm dark:bg-gray-700" />
                                <span>{form?.secondImageStickerStampSize}%</span>
                              </div>
                            </div>
                          </>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
            <div className="text-right">
              {form?.image &&
                <button type="button" onClick={() => setIsOpen(true)} className="text-white bg-[#f98745]  focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">
                  Preview
                </button>
              }
              <button type="submit" className="text-white bg-[#f98745]  focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">
                {id ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </form>
      </Layout>

      {/* Preview Modal */}
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={() => setIsOpen(false)}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-6xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <div className="flex items-center justify-between">
                    <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                      Preview Card
                    </Dialog.Title>
                    <button type="button" onClick={() => setIsOpen(false)} className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2">
                      Close
                    </button>
                  </div>
                  <div className="flex items-center justify-center">
                    <CardAnimation detail={form} />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default AddEditCard;